module.exports = __webpack_public_path__ + "static/media/21.Auto-Level.a88c5109.webp";